module.exports = __webpack_public_path__ + "static/media/Garlic.d90eb326.webp";